import styled from 'styled-components';

const CountdownContainer = styled.div`
  background: white;
  border-radius: 8px;
  box-shadow: 0px 15px 40px rgba(11, 26, 33, 0.1);
  padding: 20px;
`;

const CountdownInnerContainer = styled.div`
  background: var(--grey-1);
  display: flex;
  justify-content: space-between;
  padding: 20px 40px;

  .coundown-time {
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  h1,
  h5 {
    margin: 0;
  }

  @media (max-width: 575px) {
    padding: 15px;

    h1 {
      font-size: var(--font-size-25);
      margin-bottom: 5px;
    }

    h5 {
      font-size: var(--font-size-16);
    }
  }
`;

export { CountdownContainer, CountdownInnerContainer };
